import React from "react"
import RPMAdminComponent from "../components/RPMAdmin/RPMAdmin"

const RPMAdminView = () => <RPMAdminComponent />

export default RPMAdminView
